import { render, staticRenderFns } from "./LayersTree.vue?vue&type=template&id=3eb8c38f&scoped=true"
import script from "./LayersTree.vue?vue&type=script&lang=js"
export * from "./LayersTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb8c38f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb8c38f')) {
      api.createRecord('3eb8c38f', component.options)
    } else {
      api.reload('3eb8c38f', component.options)
    }
    module.hot.accept("./LayersTree.vue?vue&type=template&id=3eb8c38f&scoped=true", function () {
      api.rerender('3eb8c38f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/LayersTree.vue"
export default component.exports